import { DateType } from '../services/date.util';

interface ISelectOption {
  name?:string;
  value?:string;
  group?:string;
}

export class CombinedDateMetadataService {
  private options:ISelectOption[] = [
    {
      value: DateType.TODAY,
      name: 'Today'
    },
    {
      value: DateType.YESTERDAY,
      name: 'Yesterday'
    },
    {
      value: DateType.THREE_DAYS_AGO,
      name: '3 days ago'
    },
    {
      value: 'trunc(sysdate, \'iw\')',
      name: 'First of this week'
    },
    {
      value: 'trunc(sysdate+7, \'DAY\')-1',
      name: 'Last of this week'
    },
    {
      value: 'trunc(sysdate-7, \'iw\')',
      name: 'First of previous week'
    },
    {
      value: 'trunc(sysdate-7, \'DAY\')+6 ',
      name: 'Last of previous week'
    },
    {
      value: DateType.ONE_WEEK_AGO,
      name: 'One week ago'
    },
    {
      value: DateType.THIRTY_DAYS_AGO,
      name: '30 days ago'
    },
    {
      value: 'sysdate-60',
      name: '60 days ago'
    },
    {
      value: DateType.NINETY_DAYS_AGO,
      name: '90 days ago'
    },
    {
      value: 'sysdate-93',
      name: '93 days ago'
    },
    {
      value: 'sysdate-100',
      name: '100 days ago'
    },
    {
      value: DateType.ONE_YEAR_AGO,
      name: 'One year ago'
    },
    {
      value: 'trunc(sysdate,\'MM\')',
      name: 'First of this month'
    },
    {
      value: 'last_day(sysdate)',
      name: 'Last of this month'
    },
    {
      value: 'trunc(trunc(sysdate,\'MM\')-1,\'MM\')',
      name: 'First of previous month'
    },
    {
      value: DateType.LAST_OF_PREVIOUS_MONTH,
      name: 'Last of previous month'
    },
    {
      value: 'trunc(sysdate,\'Q\')',
      name: 'First of this quarter'
    },
    {
      value: 'last_day(add_months(trunc(sysdate, \'Q\'),2))',
      name: 'Last of this quarter'
    },
    {
      value: 'trunc(add_months(last_day(add_months(trunc(sysdate,\'Q\'),-1)),-3)+1)',
      name: 'First of previous quarter'
    },
    {
      value: 'trunc(last_day(add_months(trunc(sysdate,\'Q\'),-1)))',
      name: 'Last of previous quarter'
    },
    {
      value: 'trunc(sysdate,\'YYYY\')',
      name: 'First of this year'
    },
    {
      value: 'trunc(add_months(trunc(sysdate ,\'YEAR\'),12)-1)',
      name: 'Last of this year'
    },
    {
      value: DateType.FIRST_OF_PREVIOUS_YEAR,
      name: 'First of previous year'
    },
    {
      value: 'trunc(add_months(trunc(sysdate,\'YEAR\'),-1)+30)',
      name: 'Last of previous year'
    }
  ];

  public getMetaData():ISelectOption[] {
    return this.options;
  }
}